import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../modules/utils/snackbar/snackbar.component";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar,private router:Router) {}
  public openSnackBar(message: string, action: string, snackType?: string) {
    // const _snackType = snackType !== undefined ? snackType : "Success";

   this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 5000,
      // horizontalPosition: "end",
      // verticalPosition: "top",
      // panelClass: snackType,
      data: { message: message, action: action, snackType: snackType }
      
    });
 
  
  }
  showSnackbarAction(content, action,id) {
    let snack = this.snackBar.open(content, action);
    snack.afterDismissed().subscribe(() => {
      console.log("This will be shown after snackbar disappeared");
    });
    snack.onAction().subscribe(() => {
      this.router.navigateByUrl('/home/orders/order-details/'+id)
      console.log("This will be called when snackbar button clicked");
    });
  }
}
